"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Repository = void 0;
const lodash_1 = require("lodash");
const Permission_1 = require("./Permission");
class Repository {
    constructor(itemKey) {
        this.itemKey = itemKey;
        this.storedItems = [];
        this.permissions = [];
    }
    getRepo() {
        return {
            storedItems: this.storedItems,
            permissions: this.permissions,
        };
    }
    initRepo(storedItems, permissions) {
        this.storedItems = storedItems;
        this.permissions = permissions;
    }
    addItem(item, permissions) {
        // Can only add an item to the store that has been
        // initialized using initRepo
        if (this.isPopulated()) {
            this.storedItems = [...this.storedItems, item];
            this.permissions = [...this.permissions, ...permissions];
        }
    }
    updateItem(newValue) {
        this.storedItems = this.storedItems.map((item) => {
            if (item[this.itemKey] == newValue[this.itemKey])
                return newValue;
            return item;
        });
    }
    isPopulated() {
        const populated = this.storedItems.length > 0 || this.permissions.length > 0;
        return populated && this.permissionsAreFresh();
    }
    permissionsAreFresh() {
        return (0, lodash_1.every)(this.permissions, (permission) => {
            return Permission_1.Permission.validateJwtExpiry(permission.token);
        });
    }
    clear() {
        this.storedItems = [];
        this.permissions = [];
    }
}
exports.Repository = Repository;
